import React, {useState} from 'react'
import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    // Select,
    // Form,
    Input,
    // DatePicker
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
// const { Item } = Form;
const { Search } = Input;
// const { Option } = Select;
const { confirm } = Modal;

const ExhibitorsPayment = () => {
  const navigate = useNavigate()

  const [filterConfig, setFilterConfig] = useState({
    payment_id: "",
    type: "tenant",
    status: "open",
  })

  function ActionBtn(row) {
    const items = [
        {
            label: (
                <div onClick={()=> navigate('/preview-exhibitor-payment')}>
                    Print Preview
                </div>
            ),
            key: '2',
        },
       
        {
            label: (
                <div style={{color: 'red'}} onClick={showDeleteConfirm}>
                    Delete
                </div>
            ),
            key: '3',
        },
    ];

    return (
      <>
        <span className='center'>
          <Dropdown
            menu={{
            items,
            }}
            trigger={['click']}
          >
            <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
              <Space>
                <MoreVert />
              </Space>
            </div>
          </Dropdown>
        </span>
      </>
    );
  }

  const showDeleteConfirm = () => {
      confirm({
        title: 'Are you sure delete this Property?',
        icon: <ExclamationCircleFilled />,
      //   content: 'Some descriptions',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
        },
        onCancel() {
        },
      });
    };

  
  const data = [
      {
        key: '1',
        payment_no: '1',
        name: 'name 1',
        payment_date: 'January 1 2024',
        paid_amount: '2 000',
        balance: '2 000',
        remarks: 'remark 1',
        issued_by: 'user 1',
      },
      {
        key: '2',
        payment_no: '2',
        name: 'name 2',
        payment_date: 'February 1 2024',
        paid_amount: '5 000',
        balance: '8 000',
        remarks: 'remark 2',
        issued_by: 'user 2',
      },
      {
        key: '3',
        payment_no: '3',
        name: 'name 3',
        payment_date: 'March 1 2024',
        paid_amount: '2 000',
        balance: '1 000',
        remarks: 'remark 3',
        issued_by: 'user 3',
      },
      {
        key: '4',
        payment_no: '4',
        name: 'name 4',
        payment_date: 'April 1 2024',
        paid_amount: '8 000',
        balance: '4 000',
        remarks: 'remark 4',
        issued_by: 'user 4',
      },
  ];

  const onSearch = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e.target.value || ''
      }
  ));
};   
  return (
      <Layout className='page'>
          <Navbar navKey={'exhibitors_payment_nav'}/>
          <Layout className='content-container'>
            <Row>
              <Col span={14} className='header-container p-4'>
                  EXHIBITORS PAYMENTS
              </Col>
              <Col span={10} className='pt-4'>
                <Row>
                  <Col span={14} className='p-4'>
                    <Search placeholder="input search text" size='medium' allowClear onSearch={onSearch} style={{ width: 250 }} />
                  </Col>
                  <Col span={10} className='p-4'>
                    <Button className='button-color btn-header' onClick={() => navigate('/add-exhibitor-payment')} type="primary">+ Add Exhibitor Payment</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='page-content'>
              <Col span={24}>
                <AntDTable
                  tableHeaders={[
                    "Payment No.",
                    "Exhibitor Name",
                    "Payment Date",
                    "Paid Amount",
                    "Balance",
                    "Remarks",
                    "Issued By",
                  ]}
                  headerSelector={[
                    "payment_no",
                    "name",
                    "payment_date",
                    "paid_amount",
                    "balance",
                    "remarks",
                    "issued_by",
                  ]}
                  tableData={data}
                  ActionBtn={(row) => ActionBtn(row)}
                  withAction={true}
                  // loading={showLoader}
                  // isClickable={true}
                  // rowClickPath={"/patients/profile"}
                  tablePages={10}
                  // handleTableChange={handleTableChange}
                  // filterConfig={filterConfig}
                  // totalSize={totalSize}
                  isSearch={true}
                />
              </Col>
            </Row>
        </Layout>
      </Layout>
  )
}

export default ExhibitorsPayment
